export default "__VITE_ASSET__DXkaha4Z__"